// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingGuaranteeTransactionResponse

import { hydrateCustomer, type Customer, type CustomerApiResponse } from './customer.gen';
import { hydrateBooking, type Booking, type BookingApiResponse } from './booking.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingGuaranteeTransactionApiResponse = {
	id: number;
	amount: number;
	fee: number;
	createdAt: string;
	effective_date: string;
	status: string;
	type: string;
	operation: string;
	method: string;
	booking_id: string;
	booking_date: string;
	booking_status: string;
	booking_pax: number;
	customer_id: string | null;
	customer_name: string | null;
	customer_firstname: string | null;
	customer_lastname: string | null;
	customer_email: string | null;
	customer_phone: string | null;
	customer: CustomerApiResponse | null;
	booking: BookingApiResponse | null;
};

export type BillingGuaranteeTransaction = {
	id: number;
	amount: number;
	fee: number;
	createdAt: DateTime;
	effective_date: DateTime;
	status: string;
	type: string;
	operation: string;
	method: string;
	booking_id: string;
	booking_date: DateTime;
	booking_status: string;
	booking_pax: number;
	customer_id: string | null;
	customer_name: string | null;
	customer_firstname: string | null;
	customer_lastname: string | null;
	customer_email: string | null;
	customer_phone: string | null;
	customer: Customer | null;
	booking: Booking | null;
};

export function hydrateBillingGuaranteeTransaction(data: BillingGuaranteeTransactionApiResponse): BillingGuaranteeTransaction {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		effective_date: DateTimefromISO(data.effective_date)!,
		booking_date: DateTimefromISO(data.booking_date)!,
		customer: data.customer ? hydrateCustomer(data.customer) : null,
		booking: data.booking ? hydrateBooking(data.booking) : null,
	};
}